/* TCW theme – global behaviour: cart (AJAX + drawer), header menu, accordions, scroll reveal.
   Vanilla JS, no dependencies. Section-specific behaviour lives in sections.js and product.js. */
(function () {
  'use strict';

  var theme = window.theme || (window.theme = {});
  var strings = theme.strings || {};
  var routes = theme.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  theme.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || theme.moneyFormat || '€{{amount_with_comma_separator}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  };

  /* ---------- Small helpers ---------- */
  theme.onSectionLoad = function (fn) {
    document.addEventListener('shopify:section:load', function (e) { fn(e.target); });
  };
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Scroll reveal (.reveal / .reveal-stagger) ---------- */
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }) : null;
  theme.initReveal = function (root) {
    qsa(root, '.reveal, .reveal-stagger').forEach(function (el) {
      if (!revealObserver || reduceMotion) { el.classList.add('is-visible'); return; }
      revealObserver.observe(el);
    });
  };

  /* ---------- Accordions (product tabs, FAQ, mini FAQ) ---------- */
  var ACCORDIONS = [
    ['[data-faq-trigger]', '[data-faq-icon]'],
    ['[data-info-trigger]', '[data-info-icon]'],
    ['[data-mini-faq-trigger]', '[data-mini-faq-icon]']
  ];
  function setAccordion(trigger, open) {
    var panel = trigger.nextElementSibling;
    var icon = null;
    ACCORDIONS.forEach(function (pair) { if (trigger.matches(pair[0])) icon = trigger.querySelector(pair[1]); });
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (icon) icon.style.transform = open ? 'rotate(45deg)' : 'rotate(0deg)';
    if (!panel) return;
    if (open) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.addEventListener('transitionend', function handler(ev) {
        if (ev.propertyName === 'max-height' && trigger.getAttribute('aria-expanded') === 'true') panel.style.maxHeight = 'none';
        panel.removeEventListener('transitionend', handler);
      });
    } else {
      if (panel.style.maxHeight === 'none') { panel.style.maxHeight = panel.scrollHeight + 'px'; panel.offsetHeight; }
      requestAnimationFrame(function () { panel.style.maxHeight = '0px'; });
    }
  }
  document.addEventListener('click', function (e) {
    for (var i = 0; i < ACCORDIONS.length; i++) {
      var trigger = e.target.closest(ACCORDIONS[i][0]);
      if (!trigger) continue;
      var open = trigger.getAttribute('aria-expanded') !== 'true';
      var scope = trigger.closest('.shopify-section') || document;
      qsa(scope, ACCORDIONS[i][0]).forEach(function (t) { if (t !== trigger && t.getAttribute('aria-expanded') === 'true') setAccordion(t, false); });
      setAccordion(trigger, open);
      return;
    }
  });
  // Links to #anchors open the accordion / <details> they point at (e.g. "Come misurare?" → FAQ)
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link || link.getAttribute('href').length < 2) return;
    var target;
    try { target = document.querySelector(link.getAttribute('href')); } catch (err) { return; }
    if (!target) return;
    if (target.tagName === 'DETAILS') target.open = true;
    var trigger = target.matches('[data-faq-trigger],[data-info-trigger],[data-mini-faq-trigger]') ? target : target.querySelector('[data-faq-trigger],[data-info-trigger],[data-mini-faq-trigger]');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    if (trigger || target.tagName === 'DETAILS') {
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  });

  /* ---------- Header: mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-menu-toggle]');
    if (!btn) return;
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? (strings.closeMenu || 'Close menu') : (strings.openMenu || 'Open menu'));
  });
  // Close dropdown menus when clicking elsewhere
  document.addEventListener('click', function (e) {
    qsa(document, '.ph-nav__dropdown[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- Cart ---------- */
  var cart = theme.cart = {};
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  var lastFocus = null;

  cart.open = function () {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tcw-drawer-open');
    var panel = d.querySelector('.tcw-drawer__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 50);
    return true;
  };
  cart.close = function () {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tcw-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  cart.renderSections = function (sections) {
    if (!sections) return;
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var newPanel = doc.querySelector('.tcw-drawer__panel');
      var d = drawer();
      var panel = d && d.querySelector('.tcw-drawer__panel');
      if (newPanel && panel) panel.innerHTML = newPanel.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      var b = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('[data-cart-count]');
      if (b) qsa(document, '[data-cart-count]').forEach(function (el) {
        if (el.closest('[data-cart-drawer]')) return;
        el.textContent = b.textContent.trim();
        el.classList.remove('poof-pop'); void el.offsetWidth; el.classList.add('poof-pop');
      });
    }
  };

  function showError(container, message) {
    if (!container) { window.alert(message); return; }
    container.textContent = message;
    container.hidden = false;
  }

  cart.add = function (form, button) {
    var errorBox = form.querySelector('[data-form-error]');
    if (errorBox) errorBox.hidden = true;
    var body = new FormData(form);
    body.append('sections', SECTIONS.join(','));
    body.append('sections_url', window.location.pathname);
    if (button) { button.setAttribute('aria-busy', 'true'); button.classList.add('is-loading'); }
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          showError(errorBox, res.data.description || res.data.message || strings.cartError);
          return;
        }
        cart.renderSections(res.data.sections);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: res.data }));
        if (theme.cartType === 'drawer' && cart.open()) return;
        window.location.href = routes.cart;
      })
      .catch(function () { showError(errorBox, strings.cartError); })
      .finally(function () { if (button) { button.removeAttribute('aria-busy'); button.classList.remove('is-loading'); } });
  };

  cart.change = function (line, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-loading');
    var errorBox = d && d.querySelector('[data-cart-error]');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { showError(errorBox, res.data.description || res.data.message || strings.cartError); return; }
        cart.renderSections(res.data.sections);
      })
      .catch(function () { showError(errorBox, strings.cartError); })
      .finally(function () { if (d) d.classList.remove('is-loading'); });
  };

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && theme.cartType === 'drawer' && drawer()) { e.preventDefault(); cart.open(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); cart.close(); return; }
    var change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      cart.change(parseInt(change.getAttribute('data-cart-change'), 10), parseInt(change.getAttribute('data-quantity'), 10));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer() && drawer().classList.contains('is-open')) cart.close();
    // keep focus inside the open drawer
    if (e.key === 'Tab' && drawer() && drawer().classList.contains('is-open')) {
      var focusables = qsa(drawer(), 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- "Poof" sparkle on add-to-cart buttons (from the original design) ---------- */
  theme.sparkle = function (btn) {
    if (!btn || reduceMotion) return;
    btn.classList.remove('poof-pop'); void btn.offsetWidth; btn.classList.add('poof-pop');
    var colors = ['text-butter', 'text-poof', 'text-dream'];
    if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
    for (var i = 0; i < 6; i++) {
      var s = document.createElement('span');
      s.textContent = '✦';
      s.setAttribute('aria-hidden', 'true');
      s.className = 'spark-pop absolute ' + colors[i % colors.length] + ' text-lg pointer-events-none';
      var angle = Math.PI * 2 * i / 6, dist = 46 + Math.random() * 20;
      s.style.setProperty('--dx', Math.cos(angle) * dist + 'px');
      s.style.setProperty('--dy', Math.sin(angle) * dist + 'px');
      s.style.left = '50%'; s.style.top = '50%';
      btn.appendChild(s);
      setTimeout(function (el) { el.remove(); }, 700, s);
    }
  };

  /* ---------- Sort select auto-submit (collection / search) ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-auto-submit]') && e.target.form) e.target.form.submit();
  });

  /* ---------- Init ---------- */
  function init(root) { theme.initReveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  theme.onSectionLoad(init);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) cart.close();
  });
})();
